import { OutlinedSelectOptionType } from '@octano/global-ui';
import { PaginationQueryDto } from '../../../types/paginationRequestType';
export enum ClassesBookItemStatus {
  Associated = 'associated',
  NonAssociates = 'non_associated',
}

export type SearchParams<T> = {
  period?: T;
  school?: T;
  campus?: T;
  section?: T;
  course?: T;
  hasFilters?: boolean;
};

export type ClassesBookForm = {
  periods: OutlinedSelectOptionType[];
  schools: OutlinedSelectOptionType[];
  campuses: OutlinedSelectOptionType[];
  sections: OutlinedSelectOptionType[];
  courses: OutlinedSelectOptionType[];
};

export type ClassesBookItem<T> = {
  period: {
    id: number;
    name: string;
  };
  section: {
    id: number;
    name: string;
  };
  course: {
    id: number;
    code: string;
    name: string;
  };
  school: {
    id: number;
    name: string;
  };
  campus: {
    id: number;
    name: string;
  };
  syllabusUrl: string;
  status: ClassesBookItemStatus;
  report?: T;
};

export type ClassesBookTableQuery = PaginationQueryDto<SearchParams<string>>;

export interface ClassesBookTableResponse {
  data: ClassesBookItem<any>[];
  total: number;
  total_pages: number;
}

export enum ClassesBookActivitiesStatus {
  Loaded = 'loaded',
  NonLoaded = 'non_loaded',
}

export interface CourseLearningUnit {
  id: number;
  title: string;
  hours: number;
}

export interface LessonActivity {
  id: number;
  sectionScheduleId: number;
  courseLearningUnitId: number;
  criteria: string | null;
  contents: string | null;
  activities: string | null;
  courseLearningUnit?: CourseLearningUnit | null;
}

export interface IClassesBookClassItem {
  id: number;
  sectionId: number;
  name: string;
  date: string;
  status: ClassesBookActivitiesStatus;
  activities: LessonActivity[];
}

export interface ClassesBookClassResponse {
  classes: IClassesBookClassItem[];
  courseLearningUnits: CourseLearningUnit[];
  activitiesLimit: number;
  details: {
    sectionCode: string;
    courseName: string;
    schoolName: string;
    periodName: string;
  };
}
